module.exports = __webpack_public_path__ + "img/arc-emblem-white.af42165f.svg";